import { Outlet, useNavigate } from "react-router-dom"
import { useCurrentUserMaybe } from "../auth/CurrentUserContext"
import { useEffect } from "react"
import { accountPath } from "~/common/paths"

export const RequireUserSignedOut = () => {
  const navigate = useNavigate()
  const { currentUser } = useCurrentUserMaybe()

  useEffect(() => {
    if (currentUser) {
      navigate(accountPath.pattern)
    }
  }, [currentUser, navigate])

  return <Outlet />
}
